/**
 * Field formatters and display labels for the Related Parties change-history
 * feed.
 *
 * Used by: `RelatedPartyDetailPanel.tsx` -> `<ChangeHistory />`.
 */

const PARTY_TYPE_LABELS: Record<string, string> = {
  individual: "Individual",
  entity: "Entity",
};

const RELATIONSHIP_STATUS_LABELS: Record<string, string> = {
  current: "Current",
  former: "Former",
  prospective: "Prospective",
};

const RELATIONSHIP_CATEGORY_LABELS: Record<string, string> = {
  director: "Director",
  shareholder: "Shareholder",
  officer: "Officer",
  family_member: "Family member",
  associate_entity: "Associated entity",
  spouse: "Spouse",
  parent: "Parent entity",
  subsidiary: "Subsidiary",
  trust: "Trust",
  beneficiary: "Beneficiary",
  business_partner: "Business partner",
  other: "Other",
};

const REVIEW_STATUS_LABELS: Record<string, string> = {
  pending_review: "Pending review",
  reviewed: "Reviewed",
  flagged: "Flagged",
};

export const RELATED_PARTY_FIELD_FORMATTERS: Record<
  string,
  (value: unknown) => string
> = {
  legalName: (v) => String(v ?? "\u2014"),
  acn: (v) => String(v ?? "\u2014"),
  abn: (v) => String(v ?? "\u2014"),
  summary: (v) => String(v ?? "\u2014"),
  analystNotes: (v) => String(v ?? "\u2014"),
  internalNote: (v) => String(v ?? "\u2014"),
  partyType: (v) => PARTY_TYPE_LABELS[String(v)] ?? String(v ?? "\u2014"),
  relationshipStatus: (v) =>
    RELATIONSHIP_STATUS_LABELS[String(v)] ?? String(v ?? "\u2014"),
  relationshipCategory: (v) =>
    RELATIONSHIP_CATEGORY_LABELS[String(v)] ?? String(v ?? "\u2014"),
  reviewStatus: (v) => REVIEW_STATUS_LABELS[String(v)] ?? String(v ?? "\u2014"),
  confidenceScore: (v) =>
    typeof v === "number" ? `${Math.round(v * 100)}%` : String(v ?? "\u2014"),
};

export const RELATED_PARTY_FIELD_LABELS: Record<string, string> = {
  legalName: "Legal name",
  acn: "ACN",
  abn: "ABN",
  partyType: "Party type",
  relationshipStatus: "Relationship status",
  relationshipCategory: "Relationship category",
  summary: "Summary",
  analystNotes: "Analyst notes",
  internalNote: "Internal note",
  confidenceScore: "Confidence",
  reviewStatus: "Review status",
};
